module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  }), _vm._v(" "), _c('consult-float')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f873636a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 742
// module chunks = 37